function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}
if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
        }

        formSubmit(evt) {
            evt.preventDefault();
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);
            config.body = formData;

            fetch(`${theme.routes.cartAdd}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
                        return;
                    }
                    // Succses function
                    this.succses()
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        errorMessage(resp) {
            // alert(resp.description)
            console.log(resp.description);
        }

        succses() {
            console.log("Success");
            updateCartPopup();
        }
    });
}
function updateCartPopup(){
    document.querySelector('#cartModalWrapper').classList.add('loading');
    fetch('/cart?section_id=redesign-cart-modal')
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('#cartModalWrapper');
            const sourceProductList = sourceQty.querySelector('#CartPopup');
            const sourceSubtotal = sourceQty.querySelector('.js-fixedBlock');
            const productList = document.querySelector('#cartModalWrapper').querySelector('#CartPopup');
            const subtotal = document.querySelector('#cartModalWrapper').querySelector('.js-fixedBlock');
            document.querySelector('#cartModalWrapper').classList.remove('loading');
            productList.innerHTML = sourceProductList.innerHTML;
            subtotal.innerHTML = sourceSubtotal.innerHTML;
            if(!document.querySelector('.modal.cart-modal').classList.contains('show')){
                document.querySelector('[data-toggle="modal"][data-target=".cart-modal"]').click();
            }
        })
        .catch(e => {
            console.error(e);
        });
}